module.exports = __webpack_public_path__ + "img/CF_2BB.1.b4825795.jpg";